export { default as SearchInput, type SearchInputProps } from './SearchInput';
